import {
  ENGLISH_LANGUAGE_OPTION,
  GERMAN_LANGUAGE_OPTION,
  LANGUAGES_OPTIONS,
} from '../../../components/ChangeLanguage/constants';
import type { LanguageOption } from '../../../components/LanguageSelect/types';
import { SupportedCountryCodeEnum } from '../../geography/types';

export function getAllowedLanguagesForCountry(countryCode: SupportedCountryCodeEnum): LanguageOption[] {
  switch (countryCode) {
    case SupportedCountryCodeEnum.AT:
    case SupportedCountryCodeEnum.DE:
      return [GERMAN_LANGUAGE_OPTION, ENGLISH_LANGUAGE_OPTION];
    case SupportedCountryCodeEnum.US:
    case SupportedCountryCodeEnum.CA:
    case SupportedCountryCodeEnum.NZ:
      return [ENGLISH_LANGUAGE_OPTION];
    default:
      return LANGUAGES_OPTIONS;
  }
}
